// extracted by mini-css-extract-plugin
export default {"tooltip":"xQ-z","arrow":"yQ-z"};